<div id="background">
    <h3>ПРАВИЛА ИГРЫ</h3>
    <div id="block_fon">
    </div>
    <div id="block_text">
        <p>Цель: набрать ближе к 20 очков <strong>(но не превышая)</strong>. Победа — в 3 раундах.</p>
        <p>Ход игры:</p>
        <ul>
            <li>В начале — 4 карты из побочной колоды.</li>
            <li>Каждый ход добавляет случайная карта (от 1 до 10).</li>
            <li>Можно сыграть 1 карту из руки или пропустить.</li>
            <li>Можно остановиться в любой момент.</li>
        </ul>
        <p>Исходы матча:</p>
        <ul>
            <li>Ближе к 20 — победа.</li>
            <li>Перебор — проигрыш.</li>
            <li>Равенство — ничья.</li>
        </ul>
        <p>Желтые карты (2&4 и 3&6) меняют знаки соответствующих карт (для 2&4 меняет знаки 2 и 4) на противоположные. <strong>Знаки меняются только у тех карт, что уже находятся на поле.</strong></p>
        <p>Карты +- работают следующим образом - при нажатии верхей части карты она попадет на поле со знаком +, при нажатии на нижнюю половину - знак будет -.</p>
    </div>

    <button id="play" [routerLink]="'/game'">Играть</button>
    <button id="beg"    [routerLink]="'/'">Назад</button>
</div>
